import React from 'react';

export class I18nUtils {
  public static message(message: string, placeholders: Record<string, string | number>): string {
    if (placeholders === undefined) {
      return message;
    }

    Object.keys(placeholders).forEach((key) => {
      message = message.replaceAll(`{${key}}`, placeholders[key].toString());
    });

    return message;
  }

  public static richMessage(message: string, placeholders: Record<string, React.ReactNode>): React.ReactNode {
    if (placeholders === undefined) {
      return message;
    }

    let messageParts: React.ReactNode[] = [message];

    Object.keys(placeholders).forEach((key) => {
      const placeholder: React.ReactNode = placeholders[key];

      messageParts =
        typeof placeholder === 'string'
          ? messageParts.map((part) => (typeof part === 'string' ? part.replace(`{${key}}`, placeholder) : part))
          : messageParts
              .map((part) => (typeof part === 'string' ? I18nUtils.replacePlaceholder(part, key, placeholder) : [part]))
              .reduce((acc, current) => [...acc, ...current], []);
    });

    return messageParts;
  }

  private static replacePlaceholder(message: string, key: string, value: React.ReactNode): React.ReactNode[] {
    return message
      .split(`{${key}}`)
      .map((part, index) => (index === 0 ? [part] : [I18nUtils.withKey(value, `${index}-${key}`), part]))
      .reduce((acc, current) => [...acc, ...current], []);
  }

  private static withKey(node: React.ReactNode, key: string): React.ReactNode {
    // eslint-disable-next-line react/no-children-prop
    return React.createElement(React.Fragment, { key, children: node });
  }
}
